import React, { useState, useEffect } from "react";

interface ChristmasBonanzaProps {
  getStarted: () => void;
  promoActive: boolean;
  promoImage: string;
}

const ChristmasBonanza: React.FC<ChristmasBonanzaProps> = ({
  getStarted,
  promoActive,
  promoImage,
}) => {
  const [DisplayImage, setDisplayImage] = useState(false);

  useEffect(() => {
    if (promoActive) {
      const timer = setTimeout(() => {
        setDisplayImage(promoActive);
        document.body.classList.add("overflow-hidden");
      }, 2000);

      return () => {
        clearTimeout(timer);
        document.body.classList.remove("overflow-hidden");
      };
    }
  }, [promoActive]);

  const closeOverlay = (e: any) => {
    e.stopPropagation();
    setDisplayImage(false);
    getStarted();
    document.body.classList.remove("overflow-hidden");
  };

  return (
    <>
      {DisplayImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex gap-4 items-center justify-center z-[9999]"
          onClick={closeOverlay}
        >
          {/* <button
            onClick={closeOverlay}
            className="absolute top-32 right-5 lg:top-5  xl:top-5 lg:right-64 xl:right-64"
            aria-label="Close"
          >
            <img
              src="../../images/Cancel.png"
              alt="cancel-btn"
              className="h-12"
            />
          </button> */}       
         <div onClick={(e) => e.stopPropagation()}>
  <div className="relative w-[90%] max-w-[900px] mx-auto">
    <button
    onClick={closeOverlay}
    className="absolute top-3 right-3 z-20
               bg-white rounded-full shadow-lg
               p-1 hover:scale-105 transition-all"
    aria-label="Close"
  >
    <img
      src="../../images/Cancel.png"
      alt="cancel-btn"
      className="h-5 w-5 lg:h-6 lg:w-6"
    />
  </button>

    {/* Image */}
    <img
      src={promoImage}
      alt=""
      className="w-full h-auto rounded-lg shadow-lg"
    />
  </div>
</div>
        </div>
      )}
    </>
  );
};

export default ChristmasBonanza;
